"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _moment = _interopRequireDefault(require("moment"));

var _reactBootstrap = require("react-bootstrap");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _proLightSvgIcons = require("@fortawesome/pro-light-svg-icons");

var _QuestionsActions = require("../../redux/Questions/QuestionsActions");

var _config = require("../../config/config");

require("../../../css/CheckboxProperties.css");

require("../../../css/CommonProperties.css");

function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
      t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}

function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };

  var t = _getRequireWildcardCache(r);

  if (t && t.has(e)) return t.get(e);
  var n = {
    __proto__: null
  },
      a = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var u in e) {
    if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }

  return n["default"] = e, t && t.set(e, n), n;
}
/* eslint-disable no-underscore-dangle */
// Ideally this would be part of CheckboxProperties. However, the current setup for App/Onboard is such that:
// App -> Radio (type: radio) & Checkbox (type: checkbox)
// Onboard -> Radio (type: radio) & Checkbox (type: multi-select-checkbox OR radio but NOT checkbox...)
// Which means that if we use CheckboxProperties for both, we can't easily figure out if we want a radio-radio
// or a checkbox-radio even with the flag. This is a temporary solution until we can refactor...


var RadioProperties = function RadioProperties(_ref) {
  var question = _ref.question,
      updateRadioQuestion = _ref.updateRadioQuestion,
      errorMessages = _ref.errorMessages; // future refactor: make the test server remove _destroyed answers the way the real thing does so we can remove this filter

  var validAnswers = function validAnswers(answerAttributes) {
    return answerAttributes.filter(function (answer) {
      return answer._destroy !== true;
    }) || [];
  };

  var _useState = (0, _react.useState)(validAnswers(question.answers_attributes)),
      answers = _useState[0],
      setAnswers = _useState[1];

  (0, _react.useEffect)(function () {
    setAnswers(validAnswers(question.answers_attributes) || []);
  }, [question.answers_attributes]); // pushes the new answer details to local state ONLY.

  var onEditAnswer = function onEditAnswer(e) {
    var answerId = parseInt(e.target.getAttribute('answerid'), 10);
    var updatedAnswers = answers.map(function (answer) {
      if (answer.id === answerId) {
        return (0, _extends2["default"])({}, answer, {
          name: e.target.value,
          _destroy: false
        });
      }

      return answer;
    });
    setAnswers(updatedAnswers);
  }; // pushes answer changes up to server. This is to reduce hammering the server with every keypress.


  var onAnswerBlur = function onAnswerBlur() {
    var updatedQuestion = (0, _extends2["default"])({}, question, {
      answers_attributes: answers
    });
    updateRadioQuestion(updatedQuestion, (0, _moment["default"])().format('LLL'));
  };

  var onRemoveAnswer = function onRemoveAnswer(e) {
    // Prevent removing the last answer
    if (answers.length <= 1) {
      return;
    }

    var updatedQuestion = (0, _extends2["default"])({}, question, {
      answers_attributes: answers.map(function (answer) {
        if (answer.id === parseInt(e.target.getAttribute('answerid'), 10)) {
          return (0, _extends2["default"])({}, answer, {
            _destroy: true
          });
        }

        return answer;
      })
    });
    updateRadioQuestion(updatedQuestion, (0, _moment["default"])().format('LLL'));
  };

  var onAddAnswer = function onAddAnswer() {
    var _question$data, _question$data2, _question$data3;

    var verticalSpacing = 5; // spacing between answers in percentage

    var lowestY = 0; // Default y-position
    // Find the lowest y-position among existing answers

    lowestY = Math.max.apply(Math, answers.map(function (answer) {
      var _answer$data;

      return (_answer$data = answer.data) !== null && _answer$data !== void 0 && _answer$data.pos ? answer.data.pos[1] : 0;
    })); // Create a base position if none exists

    var basePos = ((_question$data = question.data) === null || _question$data === void 0 ? void 0 : _question$data.pos) || [0, 0, 0, 0];
    var newAnswer = {
      name: "Option " + (answers.length + 1),
      position: answers.length + 1,
      _destroy: false,
      data: {
        pos: [basePos[0], lowestY + verticalSpacing, // place below the lowest answer
        basePos[2], basePos[3]],
        page: ((_question$data2 = question.data) === null || _question$data2 === void 0 ? void 0 : _question$data2.page) || 1,
        size: ((_question$data3 = question.data) === null || _question$data3 === void 0 ? void 0 : _question$data3.size) || 12,
        character_spacing: '0',
        align: 'left',
        overflow: 'shrink_to_fit'
      }
    };
    var updatedQuestion = (0, _extends2["default"])({}, question, {
      answers_attributes: [].concat(answers, [newAnswer])
    });
    updateRadioQuestion(updatedQuestion, (0, _moment["default"])().format('LLL'));
  };

  var answerIsInvalid = function answerIsInvalid(answer) {
    if (errorMessages && !answer.name) {
      return true;
    }

    if (answer.name) {
      return false;
    }

    return true;
  };

  return (
    /*#__PURE__*/
    _react["default"].createElement(_react["default"].Fragment, null,
    /*#__PURE__*/
    _react["default"].createElement("h6", {
      className: "font-weight-bold mt-2"
    }, "Answers"),
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "mb-3"
    }, answers.map(function (answer, i) {
      return (
        /*#__PURE__*/
        _react["default"].createElement(_react.Fragment, {
          key: answer.id
        },
        /*#__PURE__*/
        _react["default"].createElement(_reactBootstrap.InputGroup, {
          className: "mb-2"
        },
        /*#__PURE__*/
        _react["default"].createElement(_reactBootstrap.FormControl, {
          "aria-label": "Radio Option",
          placeholder: "Option " + (i + 1),
          "aria-describedby": "option-addon",
          className: "form-input",
          id: "btnChoiceOption" + i,
          answerid: answer.id,
          onClick: function onClick() {} // Empty handler to prevent click propagation
          ,
          onFocus: function onFocus() {},
          onBlur: onAnswerBlur,
          name: "answers",
          onChange: onEditAnswer,
          isInvalid: answerIsInvalid(answer),
          value: answer.name || ''
        }), answers.length > 1 &&
        /*#__PURE__*/
        _react["default"].createElement(_reactBootstrap.InputGroup.Append, null,
        /*#__PURE__*/
        _react["default"].createElement(_reactBootstrap.Button, {
          answerid: answer.id,
          onClick: onRemoveAnswer,
          variant: "light",
          className: "remove-option-button",
          style: {
            backgroundColor: 'white',
            border: '1px solid lightgray',
            borderLeft: 'none'
          }
        },
        /*#__PURE__*/
        _react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
          answerid: answer.id,
          icon: _proLightSvgIcons.faTimesCircle,
          className: "text-dark",
          onClick: onRemoveAnswer
        }))),
        /*#__PURE__*/
        _react["default"].createElement(_reactBootstrap.Form.Control.Feedback, {
          type: "invalid",
          className: "text-right"
        }, _config.CHECKBOX_OPTION_NAME_FEEDBACK)))
      );
    }),
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "text-center"
    },
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Button, {
      id: "btnAddAnswer",
      variant: "outline-primary",
      className: "w-50 my-2",
      onClick: onAddAnswer
    }, ' ', "+ Add Answer"))))
  );
};

RadioProperties.propTypes = process.env.NODE_ENV !== "production" ? {
  question: _propTypes["default"].shape({
    name: _propTypes["default"].string,
    // eslint-disable-next-line react/forbid-prop-types
    data: _propTypes["default"].object,
    question_type: _propTypes["default"].number,
    id: _propTypes["default"].number,
    // eslint-disable-next-line react/forbid-prop-types
    answers: _propTypes["default"].array,
    // eslint-disable-next-line react/forbid-prop-types
    answers_attributes: _propTypes["default"].array
  }).isRequired,
  updateRadioQuestion: _propTypes["default"].func.isRequired,
  errorMessages: _propTypes["default"].bool
} : {};
RadioProperties.defaultProps = {
  errorMessages: false
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateRadioQuestion: function updateRadioQuestion(question, lastSave) {
      return dispatch((0, _QuestionsActions.waitApiUpdateQuestion)(question, lastSave));
    }
  };
};

var _default = exports["default"] = (0, _reactRedux.connect)(null, mapDispatchToProps)(RadioProperties);